import { Salary_Brackets } from 'generated/apolloComponents'
import { useContext, useEffect, useState } from 'react'
import { Range, getTrackBackground } from 'react-range'
import { JobListContext, JobStateFilters } from '@/context/jobListContext'

interface iProps {
  className?: string
  name: keyof JobStateFilters
  min: number
  max: number
  step: number
  onChange: (value: number[]) => void
  value: any
}

const CustomRange = ({
  className,
  min,
  max,
  name,
  step,
  onChange,
  value,
  ...rest
}: iProps) => {
  const [values, setValues] = useState<Array<number>>(
    value ? [value.min, value.max] : [min, max]
  )
  const { state, dispatch } = useContext(JobListContext)

  useEffect(() => {
    if (state.filters) {
      setValues(
        state.filters[name]
          ? Object.values(state.filters[name] as Salary_Brackets)
          : [min, max]
      )
    }
  }, [state])

  return (
    <div
      className={`flex flex-wrap justify-between md:justify-center items-center ${className}`}
    >
      <label className='border border-gray-dark pt-2 pb-1 md:pb-0 md:pt-1 rounded-lg px-2 w-32 md:w-28 mr-6 order-1 md:order-1'>
        <p className='text-sm md:text-c10 -mb-1'>PLN</p>
        <input
          className='w-full mb-1 font-medium'
          step={step}
          type='number'
          min={min}
          max={values[1]}
          value={values[0]}
          onChange={(item) => {
            onChange([+item.target.value, values[1]])
            setValues([+item.target.value, values[1]])
          }}
        />{' '}
      </label>
      <Range
        {...rest}
        step={step}
        min={min}
        max={max}
        values={values}
        onChange={(values) => {
          setValues(values)
        }}
        onFinalChange={(values) => {
          onChange(values)
        }}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            className=' mr-10 md:mr-0 ml-5 md:ml-0 order-3 md:order-2 w-full md:w-64 md:flex-1'
            style={{
              ...props.style,
              height: '36px',
              display: 'flex',
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: '5px',
                width: '100%',
                borderRadius: '4px',
                background: getTrackBackground({
                  values,
                  colors: ['#ccc', '#000', '#ccc'],
                  min: min,
                  max: max,
                }),
                alignSelf: 'center',
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, isDragged }) => (
          <div {...props} className='w-6 h-6 rounded-full bg-black' />
        )}
      />
      <label className='border border-gray-dark rounded-lg px-2 pt-2 pb-1 md:pb-0 md:pt-1 w-32 md:w-28 ml-6 order-2 md:order-3 mr-5 md:mr-0'>
        <p className='text-sm md:text-c10 -mb-1'>PLN</p>
        <input
          className='w-full  mb-1 font-medium text-2xl mt-1 md:text-base md:mt-0'
          type='number'
          step={step}
          min={values[0]}
          max={max}
          value={values[1] <= max ? values[1] : max}
          onChange={(item) => {
            const tmpValues =
              +item.target.value <= max
                ? [values[0], +item.target.value]
                : [values[0], max]
            onChange(tmpValues)
            setValues(tmpValues)
          }}
        />
      </label>
    </div>
  )
}

export default CustomRange
